<template>
	<cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
		ref="table">
	</cTable>
</template>

<script>
	import {
		getDetails,
		setException,
		removeDetail
	} from "@/api/finance/other_fee_bill";
	import cTable from "@/base/common/index";
	import {
		getCountry
	} from "@/api/system/country";
	import {
		getAllClient,
		getCompanies
	} from "@/api/user/client";
	import {
		getUser
	} from "@/api/user/internal";
	import {
		getAgent
	} from "@/api/tracker/agent";
	export default {
		name: "dduShipment",
		components: {
			cTable,
		},
		props: {
			row: {
				type: Object,
			},
		},
		inject:['$page'],
		data() {
			return {
				methods: {
					list: (params) => {
						params.id = this.row.id
						params.v = 2
						return getDetails(params)
					},
					setException,
					removeDetail
				},
				footer: {},
				config: {
					rows:this.row,
					slot: 'div',
					height: 630,
					contentMethod({
						row,
						column
					}) {
						if (column.type == "calculate_status" && row.calculate_msg) {
							return row.calculate_msg;
						}
					},
					mergeRows:[
						'checkbox','clientInfo.client_account','clientInfo.shipper_company_cn',"target_type_txt",'clientInfo.salesman_account','clientInfo.ownership_name','numbers',
						'finance_status_txt','bill_number','create_time','to_total_amount',
						'rateInfo.to_currency',...['cny','usd','sar','qar','kwd'].map(t=>'rateInfo.'+t+'_to_rate'),
					],
					mergeRow:'numbers',
				},
				modals: {
					hang: {
					  methods: {
					    ok({ row, close }) {
					      let data = row;
					      data.ids = this.$page.selectAll.map((item) => item.id);
					      data.id = this.$page.config.rows.id;
					      this.$page.handleRequestMethods("setException", data).then((res) => {
					        this.$Message["success"]({
					          background: true,
					          content: res.msg,
					        });
					        this.$page.getList();
					        close();
					      });
					    },
					  },
					  config: {
					    modalBind: {
					      width: 600,
					      draggable: true,
					    },
					    formBind: {
					      labelWidth: 80,
					    },
					    rowBind: {
					      gutter: 16,
					      style: {
					        marginBottom: "20px",
					      },
					    },
					    rules: {
					      remarks: [
					        {
					          required: true,
					          message: "cannot be empty",
					          trigger: "blur",
					        },
					      ],
					    },
					  },
					  grid: [{ remarks: 24 }],
					  fields: [
					    {
					      name: () => this.$t("Remarks"),
					      key: "remarks",
					      component: "Input",
					      placeholder() {
					        return this.$t("enter") + this.$t("Remarks");
					      },
					      bind: {
					        type: "textarea",
					        rows: 5,
					      },
					    },
					  ],
					},
				},
				header: {
					searchs: [{
						key: "keywords",
						placeholder() {
							return this.$t("keyword");
						},
						bind: {
							style: "width:140px",
							type: "textarea",
							rows: 1
						},
						component: "Input"
					}],
					btns: {
						list: [

							{
								name: () => this.$t("export"),
								type: "export",
								fnName: "export",
								bind: {
									icon: "md-arrow-down",
									type: "primary",
								},
							},
							// {
							//   name: this.$t("hang"),
							//   type: "hang",
							//   fnName: "hang",
							//   bind: {
							//     icon: "md-trash",
							//     type: "error",
							//   },
							//   disabled() {
							//     return (
							//       !this.selectAll.length
							//     );
							//   },
							// },
							{
							  name: this.$t("delete"),
							  type: "delete",
							  fnName: "delete",
							  bind: {
							    icon: "md-trash",
							    type: "error",
							  },
							  disabled() {
							    return (
							      !this.selectAll.length
							    );
							  },
							},
						],
						methods: {
							export:() => {
								this.$page.handleRequestMethods("Export", this.row.id).then((res) => {
									this.$Message["success"]({
										background: true,
										content: res.msg,
									});
									window.open(this.$globalUrl + res.payload)
								});
							},
							hang() {
								this.getModal("hang").open({}, function () {
									this.setTitle(this.$t("hang"));
								});
							},
							delete() {
								this.$Modal.confirm({
									title: this.$t("whether") + this.$t("delete"),
									width: 300,
									content: this.$t("titleModal"),
									onOk: () => {
										let data = {
											id: this.config.rows.id,
											ids: this.selectAll.map((item) => {
												return item.id;
											}),
										};
										this.handleRequestMethods("removeDetail", data).then(
											(res) => {
												this.$Message["success"]({
													background: true,
													content: res.msg,
												});
												this.getList();
											}
										);
									},
								});
							},
						},
					},
				},
				fields: [
					{
						type: 'checkbox',
						align: 'center',
						width: 60,
						fixed: 'left'
					},
					{
						name: () => this.$t('clientName'),
						key: 'clientInfo.client_account',
						minWidth: 110,
					},
					{
						name: () => this.$t('customerCompanyName'),
						key: 'clientInfo.shipper_company_cn',
						minWidth: 110,
					},
					{
					  name: () => this.$t("CollectionUser"),
					  key: "target_type_txt",
					  width: 100
					},
					{
						name: () => this.$t('salesman'),
						key: 'clientInfo.salesman_account',
						minWidth: 110,
					},
					{
						name: () => this.$t('ownership'),
						key: 'clientInfo.ownership_name',
						minWidth: 110,
					},
					{
						name: () => this.$t('Odd_Numbers'),
						key: 'numbers',
						minWidth: 110,
					},
					{
						name: () => this.$t('appointmentNumber'),
						key: 'base_data.reserve_number',
						minWidth: 110,
					},
					{
						name: () => this.$t('Delivery Time'),
						key: 'base_data.send_time',
						minWidth: 110,
					},
					{
						name: () => this.$t('Delivery Type'),
						key: 'base_data.service_code',
						minWidth: 110,
					},
					{
						name: () => this.$t('warehouse'),
						key: 'base_data.warehouse',
						minWidth: 110,
					},
					{
						name: () => this.$t('batch_number'),
						key: 'base_data.batch_no',
						minWidth: 110,
					},
					{
						name: () => this.$t('invoiceWeight'),
						key: 'base_data.actual_weight',
						minWidth: 110,
					},
					{
						name: () => this.$t('square'),
						key: 'base_data.volume',
						minWidth: 110,
					},
					{
						name: () => this.$t('CTNS'),
						key: 'base_data.piece_nums',
						minWidth: 110,
					},
					{
						name: () => this.$t('PCS Count'),
						key: 'base_data.pcs_nums',
						minWidth: 110,
					},
					{
						name: () => this.$t('carton_nums'),
						key: 'base_data.carton_nums',
						minWidth: 110,
					},
					{
						name: () => this.$t('inboundTime'),
						key: 'base_data.in_time',
						minWidth: 110,
					},
					
					{
						name: () => this.$t('Stroage Days'),
						key: 'base_data.storage_days',
						minWidth: 110,
					},
					
					{
						name: () => this.$t('quantity1'),
						key: 'base_data.charges_value',
						minWidth: 110,
					},
					{
						name: () => this.$t('Transit Time'),
						key: 'base_data.trans_time',
						minWidth: 110,
					},
					{
						name: () => this.$t('Transit Destination'),
						key: 'base_data.trans_location',
						minWidth: 110,
					},
					{
						name: () => this.$t('price_t')+ this.$t('Remarks'),
						key: 'base_data.amount_remarks',
						minWidth: 110,
					},
					{
						name: () => this.$t('service remark'),
						key: 'base_data.kefu_remarks',
						minWidth: 200,
					},
					
					{
						name: () => this.$t('SettlementStatus'),
						key: 'finance_status_txt',
						minWidth: 110,
					},
					// {
					// 	name: () => this.$t('offerer'),
					// 	key: 'finance_name',
					// 	minWidth: 110,
					// },
					// {
					// 	name: () => this.$t('QuotationConfirmTime'),
					// 	key: 'finance_time',
					// 	minWidth: 110,
					// },
					{
						name: () => this.$t('bill_number'),
						key: 'bill_number',
						minWidth: 110,
						component: "a",
						methods: {
							click({ row }) {
								this.$page.toPage("other_fee_bill_hq",row.bill_number)
							},
						},
					},
					// {
					// 	name: () => this.$t('Remarks'),
					// 	key: 'remarks',
					// 	minWidth: 110,
					// },
					// {
					// 	name: () => this.$t('createUser'),
					// 	key: 'creator_name',
					// 	minWidth: 110,
					// },
					{
						name: () => this.$t('createTime'),
						key: 'create_time',
						minWidth: 110,
					},
					
					{
					  name: () => this.$t("to") + this.$t('rate'),
					  width: 110,
					  children: [
							'to_currency','cny','usd','sar','qar','kwd'
						].map(t=>{
							let data = {
								name: t=== 'to_currency'?this.$t('toCurrency'): t.toUpperCase(),
								key: 'rateInfo.'+(t=== 'to_currency'?t:t+'_to_rate'),
								width: 95,
							}
							return data
						})
					},
					{
						name: () => this.$t('total'),
						key: 'to_total_amount',
						minWidth: 110,
						fixed:'right',
					},
				],
			};
		},
		async mounted() {
			let fromCountry = (await getCountry({
				allow_depart: 1
			})).data.payload.rows;
			let toCountry = (await getCountry({
				allow_arrive: 1
			})).data.payload.rows;
			let client = (await getAllClient()).data.payload.rows;
			let salesman = (await getUser({
				standard: "Salesman"
			})).data.payload.rows;
			let companiesList = (await getCompanies()).data.payload;
			let agent = (await getAgent()).data.payload.rows;
			this.header.searchs.forEach(async (item) => {
				if (item.key === "from_country") item.options = fromCountry;
				if (item.key === "to_country") item.options = toCountry;
				if (item.key === "client_id") item.options = client;
				if (item.key === "salesman_id") item.options = salesman;
				if (item.key === "ownership") item.options = companiesList;
				if (item.key === "deliver") item.options = agent;
			});
		},
	};
</script>
